export default __webpack_public_path__ + "static/media/photo--lg--huda-2.ea6fd74c.jpg";